<template>
  <div style="background: #fff">
    <titleBox name="加入旷真" imgUrl="../../assets/about/title.png"></titleBox>
    <div class="set-flex-img">
      <div class="set-img" @click="handleJump(1)">
        <img
          src="@/assets/image/joinUs/JoinUsImg1.png"
          alt=""
        />
        <div>致未来旷真人的一封信</div>
      </div>
      <div class="set-img" @click="handleJump(2)">
        <img
          src="@/assets/image/joinUs/JoinUsImg2.png"
          alt=""
        />
        <div>人才成长</div>
      </div>
      <!-- <div class="joinTopImg ba-img1" @click="handleJump(1)">
        <p class="joinTitle">致未来旷真的一封信</p>
      </div>
      <div class="joinTopImg ba-img2" @click="handleJump(2)">
        <p class="joinTitle">人才成长</p>
      </div> -->
    </div>
    <!-- 招聘邮箱 -->
    <!-- <div class="getEmail">
      <h5><van-icon name="envelop-o" class="iconfont" />招聘邮箱</h5>
      <div class="email">
        kuangzhenhr@kzspp.com
        <span style="font-size: 0.25rem">邮件名称请统一</span>
      </div>
      <div class="emailMsg">/ 旷真官网—XX地区—XX岗位应聘 /</div>
    </div>
    <div class="getEmail borderLine">
      <h5><van-icon name="phone-o" class="iconfont" />招聘电话</h5>
      <div class="email">18561738983 / 0731-89802222</div>
    </div> -->
    <div class="main" @scroll="scrollEvent($event)">
      <h2>旷真人故事<i name="arrow" class="arrowIcon"></i></h2>
      <div
        class="bigBox"
        v-for="(item, index) in newsList"
        :key="index"
        @click="toMsgPage(item.id)"
      >
        <!-- <div class="header" :style="'background-image: url(' + item.img + ')'">
        </div> -->
        <div class="gushi-box">
          <div class="gushi-img">
            <img
              :src="item.img"
              alt=""
            />
          </div>
          <div class="gushi-content">
            <div class="title">{{ item.title }}</div>
            <div class="msg">
              {{ item.summary }}
            </div>
            <div class="watchMsg">
              查看详细解读 <i name="arrow" class="arrowIcon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="loadMore" v-show="loadMoreFlag" @click="loadMore">
        加载更多...
      </div>
    </div>
  </div>
</template>

<script>
import req from "../../utils/index";
import titleBox from "@/components/titleBox";
export default {
  components: { titleBox },
  data() {
    return {
      columns: [],
      showCityChange: false,
      cityName: "",
      searchValue: "",
      list: [],
      activeName: "",
      newsList: [],
      loadMoreFlag: true,
      pageNum: 1,
    };
  },
  methods: {
    onConfirm(value) {
      this.cityName = value;
      this.onCancel();
    },
    onCancel() {
      // console.log("取消");
      this.showCityChange = false;
    },
    showCity() {
      this.showCityChange = true;
    },
    // searchChange() {
    //   let parms = {
    //     Cid: "29,30",
    //     Page: 1,
    //     Limit: 100,
    //     Title: this.searchValue,
    //     Mixed: {
    //       field_gzdd: this.cityName,
    //     },
    //   };
    //   if (!this.cityName) {
    //     delete parms.Mixed;
    //   }
    //   if (!this.searchValue) {
    //     delete parms.Title;
    //   }
    //   req("post", "api/base/articlelist", parms).then((res) => {
    //     this.list = res.data;
    //   });
    // },
    search() {
      req("post", "api/base/articlelist", {
        Cid: "49",
        Page: this.pageNum,
        Limit: 10,
      }).then((res) => {
        this.newsList = this.newsList.concat(res.data);
        if (res.data.length < 10) {
          this.loadMoreFlag = false;
        }
      });
    },
    loadMore() {
      this.pageNum = Number(this.pageNum) + 1;
      this.search();
    },
    toMsgPage(id) {
      this.$router.push("/newsMsg?id=" + id);
    },
    handleJump(type) {
      this.$router.push("talentGrowth?id=" + type);
    }
  },
  created() {
    req("get", "api/base/getice", {}).then((res) => {
      this.columns = res.fslist;
    });
    // this.searchChange();
    this.search();
  },
};
</script>

<style lang="scss" scoped>
.pos-relative {
  height: 5.4rem;
}

.set-flex-img {
  padding: 0.6rem 0rem;
  display: flex;
  justify-content: space-around;
  background-color: #f3f2f2;
  .set-img {
    width: 45%;
    img {
      width: 100%;
    }
    div {
      text-align: center;
    }
  }
}

// .joinTopImg {
//   position: relative;
//   display: block;
//   height: 5rem;
//   margin: 0.5rem auto;
//   background-repeat: no-repeat;
//   background-size: 100% 100%;

//   .joinTitle {
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     padding: 0.5rem 0 0rem 0.5rem;
//     color: #fff;
//     font-size: 0.5rem;
//   }
// }
// .ba-img1 {
//   width: 40%;
//   // margin-top: 1.5rem;
//   background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/joinUs/joinUsTopImg.png);
// }
// .ba-img2 {
//   width: 40%;
//   border-radius: 0.5rem;
//   background-image: url(https://f.kzspp.com/cms/new/images/upload/image/20171213/20171213123038_81537.png);
// }
.iconfont {
  position: relative;
  top: 0.1rem;
  font-size: 0.5rem;
  margin-right: 0.1rem;
  color: #333333;
}
.getEmail {
  position: relative;
  width: 90%;
  margin: 1rem auto;

  .iconfont {
    position: relative;
    top: 0.1rem;
    font-size: 0.5rem;
    margin-right: 0.1rem;
    color: #333333;
  }

  h5 {
    font-size: 0.4rem;
    color: #333333;
    margin: 0;
  }

  .email {
    font-size: 0.4rem;
    color: #333333;
    padding-left: 0.5rem;
    font-weight: 700;
  }

  .emailMsg {
    color: #666666;
    padding-left: 0.5rem;
  }
}

.borderLine {
  padding-bottom: 1rem;
}

.borderLine::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #d8d8d8;
  opacity: 0.2;
  content: "";
}

.searchBox {
  position: relative;
  display: flex;
  width: 90%;
  padding: 0.3rem 0;
  margin: 0.1rem auto;
  border: 0.1rem solid #dedede;
  background: #fff;
  border-radius: 5rem;

  .left {
    flex: 1.5;
    text-align: center;

    .addIcon {
      position: relative;
      top: 0.04rem;
      margin-left: 0.1rem;
      transform: rotate(90deg);
    }
  }

  .rightBox {
    position: relative;
    flex: 5;

    input {
      width: 90%;
      border: none;
      outline: none;
    }

    input::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #dedede;
    }

    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #dedede;
    }

    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #dedede;
    }

    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #dedede;
    }

    .iconfont {
      position: absolute;
      right: 2rem;
      top: 50%;
      transform: translateY(-50%);
      color: #dedede;
    }
  }
}

.zhiweiList {
  width: 90%;
  margin: 0.8rem auto;
  padding: 0.3rem 0;
  border-top: 0.07rem solid #ccc;

  .itemBox {
    margin-bottom: 0.1rem;
    border-bottom: 0.1rem solid rgba(221, 216, 216, 0.2);

    .title {
      font-size: 0.5rem;
      color: #333;
    }

    .msgBox {
      margin: 0.3rem 0;

      .littleMsgBox {
        display: inline-block;
        padding: 0.1rem 0.5rem;
        background-color: #d8d8d8;
        border-radius: 0.3rem;
        margin-right: 0.1rem;
      }
    }

    .workAddress {
      padding-bottom: 0.3rem;
      color: #333;
    }
  }
}

.showCityChangeCss {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
}
.main {
  width: 95%;
  margin: auto;

  .bigBox {
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px dashed #CCCCCC;
    .gushi-box {
      display: flex;
      justify-content: space-between;
      margin: 0.4rem auto 0.6rem auto;
      .gushi-img {
        width: 38%;
        padding-top: 0.2rem;
        img {
          width: 100%;
        }
      }
      .gushi-content {
        width: 58%;
      }
    }

    // .header {
    //   position: relative;
    //   width: 100%;
    //   height: 5rem;
    //   // background-color: #f7f4f5;
    //   background-size: 100% 100%;
    //   background-repeat: no-repeat;
    //   text-align: center;
    //   background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/itemBG.png);
    //   .isHot {
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     background-color: #fa6e23;
    //     padding: 0.05rem 0.3rem;
    //     font-family: PingFangSC-Regular, PingFang SC;
    //     border-radius: 0px 0px 6px 0px;
    //     color: #ffffff;
    //   }
    // }

    .title {
      margin: 0.2rem 0;
      color: #707070;
      font-size: 0.35rem;
      font-weight: 700;
    }

    .msg {
      font-size: 0.2rem;
      color: #666666;
      margin-bottom: 0.1rem;
      padding: 0;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .watchMsg {
      color: #AB0101;
      font-size: 10px;
      margin-top: 0.3rem;
    }
  }

  .watchMsg {
    color: #999;
  }
  .arrowIcon {
    position: relative;
    display: inline-block;
    top: -0.1rem;
    width: 12px;
    height: 7px;
    background-size: 100% 100%;
    background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/watchMsgICon.png);
  }
}

.loadMore {
  padding: 0.3rem 0;
  text-align: center;
}
</style>
